<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="operatingSystemData"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="configure">
        <Button
          type="info"
          size="small"
          @click="applicationPermission(row)"
          v-hasPermission="['aiMonitor:operatingSystem:application_config']"
          >应用配置</Button
        >
      </template>
      <!-- 删除 -->
      <template slot-scope="{ row, index }" slot="operations"></template>
    </Table>
    <!-- 删除模式框 -->
    <Modal v-model="applicationDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ applicationName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeApplication()"
          :disabled="isDisable"
          >{{ $t("common.del") }}
        </Button>
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import { getCookie } from "../../../utils/cookieUtil";
var tableOpeartingSystemVue = {};
export default {
  name: "TableOperatingSystem",
  data() {
    return {
      val: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      applicationDelmodal: false,
      applicationName: "",
      modal_loading: false,
      isDisable: false,
      columns: [
        {
          title: "公司名称",
          key: "companyName"
        },
        {
          title: "应用名称",
          key: "name"
        },
        {
          title: "告警名称",
          key: "alertRuleName"
        },
        {
          title: "状态",
          key: "stateName"
        },
        {
          title: "配置",
          slot: "configure"
        },
        {
          title: "操作",
          slot: "operations",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    "margin-right": "5px"
                  },
                  on: {
                    click: () => {
                      this.doDelete(params.index);
                      this.applicationDelmodal = true;
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array("aiMonitor:operatingSystem:delete")
                    }
                  ]
                },
                "删除"
              ),
              h(
                "i-switch",
                {
                  // 数据库0启用,1禁用
                  props: {
                    type: "primary",
                    size: "large",
                    value:
                      params.row.stateName == this.$t("alarms.common.enable")
                  },
                  on: {
                    "on-change": () => {
                      this.switch(params.index);
                    }
                  }
                },
                [
                  h("span", {
                    slot: "open",
                    domProps: {
                      innerHTML: "开启"
                    }
                  }),
                  h("span", {
                    slot: "close",
                    domProps: {
                      innerHTML: "关闭"
                    }
                  })
                ]
              )
            ]);
          }
        }
      ],
      operatingSystemData: []
    };
  },
  beforeCreate: function() {
    tableOpeartingSystemVue = this;
  },
  created() {},
  mounted: function() {
    tableOpeartingSystemVue.getOperatingSystem();
  },
  methods: {
    /**************************************分页**************************************/
    showAll: function() {
      tableOpeartingSystemVue.getOperatingSystem();
    },
    // 分页显示数据
    getOperatingSystem: function() {
      //分页
      eventBus.$on("companyId", function(val) {
        tableOpeartingSystemVue.companyId = val;
      });
      eventBus.$on("alertRuleName", function(val) {
        tableOpeartingSystemVue.alertRuleName = val;
      });
      eventBus.$on("name", function(val) {
        tableOpeartingSystemVue.name = val;
      });
      this.$api.aiMonitor
        .pageAiApplication({
          companyId: tableOpeartingSystemVue.companyId,
          alertRuleName: tableOpeartingSystemVue.alertRuleName,
          name: tableOpeartingSystemVue.name,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.operatingSystemData = res.data.records;
          for (var i = 0; i < this.operatingSystemData.length; i++) {
            // 响应时间
            if (this.operatingSystemData[i].state == 0) {
              this.operatingSystemData[i].stateName = this.$t(
                "alarms.common.enable"
              );
            } else if (this.operatingSystemData[i].state == 1) {
              this.operatingSystemData[i].stateName = this.$t(
                "alarms.common.disable"
              );
            }
          }
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableOpeartingSystemVue.getOperatingSystem();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableOpeartingSystemVue.getOperatingSystem();
    },
    /**************************************删除**************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.applicationName = this.operatingSystemData[index].name;
    },
    // 删除
    removeApplication: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //账户删除
      this.$api.aiMonitor
        .deleteAiApplication("id", this.operatingSystemData[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableOpeartingSystemVue.getOperatingSystem();
            this.isDisable = false;
            this.modal_loading = false;
            this.applicationDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    /**************************************应用配置**************************************/
    // 点击应用配置跳转
    applicationPermission: function(row) {
      this.$router.push({
        path: "/aiMonitor/applicationConfiguration/",
        query: { id: row.id, alertRuleName: row.alertRuleName }
      });
    },
    /**************************************switch**************************************/
    // switch
    switch(index) {
      this.index = index;
      // 打开是true,启用0 禁用1
      this.changeStatusMessage(this.operatingSystemData[index].id);
    },
    // 更新反馈信息某一字段
    changeStatusMessage: function(id) {
      this.$api.aiMonitor.changeStatus("id", id).then(res => {
        tableOpeartingSystemVue.getOperatingSystem();
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/operating_system/TableOperatingSystem.vue